export default "/fonts/vendor/lightgallery.js/dist/lg.woff?0add59587d07387b771f49d3f91a92af";